import React from 'react';

// React elements are objects. Read their label text instead of stringifying them.
export function optionText(node) {
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(optionText).join('');
  if (!React.isValidElement(node)) return '';
  if (node.props['aria-hidden'] === true || node.props['aria-hidden'] === 'true') return '';
  return optionText(node.props.textValue ?? node.props.children);
}
